import React from "react";
import { createBrowserRouter } from "react-router-dom";
import Layout from "../layout/Layout/layout";
import Home from "../pages/home/Home";
import ProjectDetails from "../pages/ProjectDetails/ProjectDetails";
import DataView from "../pages/DataView/DataView";
import PrivateRoute from "./Protectedroute";
import LongitudinalChart from "../components/LongitudinalChart/LongitudinalChart";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <PrivateRoute>
        <Layout>
          <Home />
        </Layout>
      </PrivateRoute>
    ),
  },
  {
    path: "/project",
    element: (
      <PrivateRoute>
        <Layout>
          <ProjectDetails />
        </Layout>
      </PrivateRoute>
    ),
  },
  {
    path: "/project/:id",
    element: (
      <PrivateRoute>
        <Layout>
          <ProjectDetails />
        </Layout>
      </PrivateRoute>
    ),
  },
  {
    path: "/dashboard",
    element: (
      <PrivateRoute>
        <Layout>
          <DataView />
        </Layout>
      </PrivateRoute>
    ),
  },
  
]);

export default router;
